@if (state$ | async; as state) {
  <div class="page-header">
    <div class="page-title">Zlecenia</div>

    <div class="header-toolbar">
      <a class="btn" [routerLink]="['/orders', 'new']">+ Nowe zlecenie</a>
    </div>
  </div>

  <!-- the board, its four columns and their headers are the layout and need no data; the board's columns
       are BOARD_COLUMNS in order, so the index matches (0128) -->
  <div class="orders-board">
    @for (column of boardColumns; track column.status; let i = $index) {
      <div class="orders-board-column">
        <div class="orders-board-column-header">
          {{ column.header }}
        </div>

        <div class="orders-board-column-content">
          @if (state.loading) {
            <!-- three cards of the card's own frame and lines, no photo slot (0081: the card does not reserve it);
                 the bar's track without its fill, as DANE draws it -->
            @for (card of shadowCards; track card) {
              <div class="order order-shadow">
                <div class="order-top">
                  <div class="order-name"><span class="shadow"></span></div>
                </div>
                <div class="order-metadata">
                  <div class="order-metadata-main">
                    <div class="order-number mb-1 text-mono"><span class="shadow"></span></div>
                    <div class="order-items"><span class="shadow"></span></div>
                  </div>

                  <div class="order-date text-mono"><span class="shadow"></span></div>
                </div>
                <div class="order-progress-bar"></div>
              </div>
            }
          } @else if (state.board) {
            @for (order of state.board.columns[i].orders; track order.id) {
              <a class="order" [routerLink]="['/orders', order.id]">
                <div class="order-top">
                  @if (order.photos.length > 0) {
                    <order-face size="card" [photos]="order.photos"></order-face>
                  }
                  <div class="order-name">{{ order.name }}</div>
                </div>
                <div class="order-metadata">
                  <div class="order-metadata-main">
                    <div class="order-number mb-1 text-mono">{{ order.orderNumber }}</div>
                    <div class="order-items">{{ order.itemsLabel }}</div>
                  </div>

                  <div class="order-date text-mono">{{ order.dateLabel }}</div>
                </div>
                <div class="order-progress-bar">
                  <div class="order-progress-fill" [style.width.%]="order.progressFraction * 100"></div>
                </div>
              </a>
            }
          }
        </div>
      </div>
    }
  </div>
}
